module.exports = __webpack_public_path__ + "img/gallery07.aaf58ba0.png";